import { render } from "./SignOutButton.vue?vue&type=template&id=7be9918a"
import script from "./SignOutButton.vue?vue&type=script&lang=js"
export * from "./SignOutButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__